import {IconButton as MuiIconButton} from '@mui/material'
import React from 'react'

interface IconButtonProps {
  icon: React.ReactNode
  onClick: () => void
  disabled: boolean
  'data-test-id'?: string
}

const buttonStyles = {
  width: '40px',
  height: '40px',
  color: '#29333d',
  padding: '12px',
  minWidth: 'auto',
  backgroundColor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  '&:focus': {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  '&:active': {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  '&:disabled': {
    color: 'rgba(41, 51, 61, 0.3)',
    backgroundColor: 'transparent'
  },
  '&.MuiIconButton-root': {
    backgroundColor: 'transparent'
  }
}

/**
 * Generic icon button with transparent background.
 * Private component used internally by QuantityInput, can be extracted if needed.
 */
export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  disabled,
  'data-test-id': dataTestId
}) => {
  return (
    <MuiIconButton
      onClick={onClick}
      disabled={disabled}
      sx={buttonStyles}
      data-test-id={dataTestId}
    >
      {icon}
    </MuiIconButton>
  )
}
